import { normalizeClientNavigationHref, normalizeClientNavigationPath } from "./client-route-family";
import type { ClientNavTransaction } from "./client-navigation-types";

export function clientRouteOwnerOwnsHref(
  owner: Pick<ClientNavTransaction, "to" | "toPath">,
  href: string
): boolean {
  const ownerHref = normalizeClientNavigationHref(owner.to);
  const hrefPath = normalizeClientNavigationPath(href);
  if (ownerHref.includes("?")) return normalizeClientNavigationHref(href) === ownerHref;
  return hrefPath === normalizeClientNavigationPath(owner.toPath);
}

export function isAllowedClientRouteOwnerChild(params: {
  owner: Pick<ClientNavTransaction, "source" | "reason" | "to">;
  currentHref: string;
  targetHref: string;
}): boolean {
  if (params.owner.source !== "local-url-tab-change" || params.owner.reason !== "tab") {
    return false;
  }

  const ownerHref = normalizeClientNavigationHref(params.owner.to);
  const currentHref = normalizeClientNavigationHref(params.currentHref);
  const targetPath = normalizeClientNavigationPath(params.targetHref);

  return (
    ownerHref === "/client/program?tab=exercises" &&
    currentHref === ownerHref &&
    targetPath.startsWith("/client/exercises/")
  );
}
